import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from "react-redux";
import configureStore from "./store";
import { defaults } from 'react-chartjs-2';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './style/index.css';


defaults.global.legend.display = false;
defaults.global.animation = false;
defaults.global.tooltips.enabled = false;

const reduxStore = configureStore(window.REDUX_INITIAL_DATA);

ReactDOM.render(
    <ReduxProvider store={reduxStore}>
        <App />
    </ReduxProvider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
